/**
 * Macht einen Listen-Bereich sortierbar, seitenschaltbar usw.
 * @param item
 * @param get_data
 * @param params
 * @param special
 */
window.ajaxItem = function(item, get_data, params, special) {
  if (typeof item != 'string') {
    return;
  }
  if (typeof params != 'object') {
    params = {};
  }

  get_data = get_data || {};
  var self = this;
  var container_list = '#list_' + item;
  if (special) {
    container_list = '#list_special_' + special;
  }

  var defaults = {
    container: container_list,
    ajax_file: 'ajax.list_' + item + '.php',
    callback: function() {
    },
  };
  var config = $.extend(defaults, params);

  this.sortBy = function(sortby) {
    self.updater({sortby: sortby});
  };

  this.changePage = function(page) {
    self.updater({page: page});
  };

  // Fügt weitere Elemente aus einem Object hinzu, um diese mit einem späteren
  // Aufruf von updater() zu berücksichtigen
  this.addFilter = function(name, filter) {
    if (typeof filter == 'object') {
      var filt = [];
      $(filter).each(function() {
        filt[filt.length] = $(this).val();
      });
      var temp = {};
      temp[name] = filt;
      get_data = $.extend({}, get_data, temp);
    }
  };

  this.updater = function(get) {
    $.ajax({
      url: MP_PATH + 'ajax/' + config.ajax_file + '?' + $.param(get_data),
      type: 'get',
      data: (typeof get != 'undefined' ? get : {}),
      cache: false,
      beforeSend: function() {
        self.showLoader();
      },
      success: function(html) {
        $(config.container).html(html);
        self.afterLoad();
      },
    });
  };

  this.poster = function(post_data) {
    $.ajax({
      url: MP_PATH + 'ajax/' + config.ajax_file,
      type: 'post',
      data: post_data,
      cache: false,
      beforeSend: function() {
        self.showLoader();
      },
      success: function(html) {
        $(config.container).html(html);
        self.afterLoad();
      },
    });
  };

  this.afterLoad = function() {
    if (typeof config.callback == 'function') {
      config.callback();
    }
  };

  this.showLoader = function() {
    $(config.container).prepend('<div class="loader" style="position:absolute;"><div class="lds-ripple"><div></div><div></div></div></div>');
  };
};

(function($) {
  /**
   * Ajax-Formulare
   * @param conf
   */
  $.fn.mpAjaxForm = function(conf) {
    $(this).find('form:first').submit(function() {
      var form = $(this);
      var ajaxform = $(form).find('input[name=ajaxform]').val();

      // Formular per Ajax senden?
      if (ajaxform > 0 && $(form).attr('enctype') !== 'multipart/form-data') {
        $(form).find('input[name=ajaxform]').attr('name', 'ajax_form');
        var form_data = $(this).find('input:not([type=checkbox],[type=checkbox],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select');

        $.ajax({
          url: form.attr('action'),
          type: form.attr('method'),
          data: form_data,
          cache: false,
          success: function(html) {
            $('#c' + ajaxform).replaceWith(html);
            $('#c' + ajaxform).mpAjaxForm(conf);
            var formtop = $('#c' + ajaxform).offset().top;

            if ($(window).scrollTop() > formtop) {
              $('html,body').animate({scrollTop: formtop}, 500);
            }
          },
        });
        return false;
      }
    });
  };
})(jQuery);

(function($) {
  $.extend({
    /**
     * Scripts asynchron laden
     * @param source
     * @param callback
     * @param cache
     */
    loadScript: function(source, callback, cache) {
      var c = (typeof cache == 'undefined' ? true : cache);
      (function(d, t) {
        var g = d.createElement(t),
            s = d.getElementsByTagName(t)[0];
        g.src = source + (c === false ? '?_=' + new Date().getTime() : '');
        g.onload = function() {
          callback();
        };
        s.parentNode.insertBefore(g, s);
      }(document, 'script'));
    },
  });
})(jQuery);

/**
 * Berechne Höhe des Headers (weil fixed)
 * und Abstand hinzufuegen
 */
window.headerAbstand = function() {
  var height = $('#header').height();
  var breadcrumbHeight = 0;
  var breadcrumb = $('#breadcrumb');

  if (breadcrumb.length) {
    breadcrumbHeight = breadcrumb.height();
  }

  var newheight = height - breadcrumbHeight;
  if ($('#header + #fader').length) {
    $('#fader').css('top', newheight);
  }

  if ($('.l-start')) {
    $('#layout').css('padding-top', newheight);
  }
};

/**
 * Oeffne Responsive Navigation
 */
window.openResponsiveNavigation = function() {
  var responsiveNavigationOuter = $('#responsive-navigation-outer');

  $('html,body').addClass('no-overflow');
  responsiveNavigationOuter.addClass('active');

  if ($('#responsive-navigation-outer ul li a.active').length > 0) {
    responsiveNavigationOuter.animate({
      scrollTop: $('#responsive-navigation-outer ul li a.active').offset().top,
    }, 500);
  }
};

/**
 * Schliesse Responsive Navigation
 */
window.closeResponsiveNavigation = function() {
  var responsiveNavigationOuter = $('#responsive-navigation-outer');

  $('html,body').removeClass('no-overflow');
  responsiveNavigationOuter.animate({scrollTop: 0}, 0);
  responsiveNavigationOuter.removeClass('active');
};

/**
 * iFrame Google Maps erst zoombar nach Klick
 */
window.googleMapsIframe = function() {
  $('.content-layout-4').children('article').children('div').click(function() {
    $(this).find('iframe').addClass('clicked');
  }).mouseleave(function() {
    $(this).find('iframe').removeClass('clicked');
  });
};

/**
 * Onepager Menu wird auchtomatisch active
 */
window.updateSectionMenu = function() {
  if ($('.onepage-click.active').length === 0) {
    $('.onepage-click-li:first-child').find('a').addClass('active');
  }

  var heightrange = $(window).height() / 2;
  var currheightrange = $(window).scrollTop() + heightrange;
  $('.op-sec').each(function() {
    var secID = $(this).attr('id');
    var upperele = $(this).offset().top;

    if (currheightrange >= upperele) {
      $('.onepage-click').removeClass('active');
      $('.' + secID).addClass('active');
    }
  });
};

/**
 * Artikelbezeichnung in Kachelansicht soll bei allen Elementen gleich hoch sein
 */
window.oneHeight = function() {
  var eleHeight = 0;
  var optionsContent = $('.options-content');
  var productList = $('#product-list');

  optionsContent.children('div').children('label').each(function() {
    if ($(this).outerHeight() > eleHeight) {
      eleHeight = $(this).outerHeight();
    }
  });
  optionsContent.children('div').children('label').css('height', eleHeight + 'px');

  eleHeight = 0;
  productList.children('ul').children('li').children('a').each(function() {
    if ($(this).outerHeight() > eleHeight) {
      eleHeight = $(this).outerHeight();
    }
  });
  productList.children('ul').children('li').children('a').css('height', eleHeight + 'px');
};

/**
 * Check Data
 */
window.checkData = function() {
  var isChecked = false;
  $('#download-list').find('input[type="checkbox"]').each(function() {
    if ($(this).is(':checked')) {
      isChecked = true;
    }
  });

  var downloadButton = $('#download-files');
  if (isChecked === true) {
    downloadButton.removeAttr('disabled');
  } else {
    downloadButton.attr('disabled', 'disabled');
  }
};

/**
 * Filter Klappbox
 */
window.filterKlappbox = function() {
  // toggle mobile filter
  $('.filter__trigger').off('click').on('click', function(e) {
    e.preventDefault();
    $('#load_filter').addClass('filter--open');
  });
  $('.filter__close').off('click').on('click', function(e) {
    e.preventDefault();
    $('#load_filter').removeClass('filter--open');
  });

  // toggle filter category
  var filterAttribute = $('.filter-attribute');
  filterAttribute.not('.open').find('.csc-body').hide();
  filterAttribute.find('.title').on('click', function() {
    $(this).parent('.filter-attribute').toggleClass('open').children('.csc-body').stop().slideToggle(250);
  });
};

/**
 * getSlideVal
 */
window.getSlideVal = function() {
  // Get slider values
  const parent = this.parentNode;
  const slides = parent.getElementsByTagName('input');

  let slideMin = parseFloat(slides[0].value);
  let slideMax = parseFloat(slides[1].value);

  // Set range-type
  slides[0].setAttribute('data-range-type', 'min');
  slides[1].setAttribute('data-range-type', 'max');

  // Neither slider will clip the other, so make sure we determine which is larger
  if (slideMin > slideMax) {
    const tmp = slideMax;
    slideMax = slideMin;
    slideMin = tmp;

    // Flip range-type
    slides[0].setAttribute('data-range-type', 'max');
    slides[1].setAttribute('data-range-type', 'min');
  }

  // Display values
  const displayElement = parent.getElementsByClassName('rangeValues')[0];
  if (displayElement !== null) {
    const rangeDigits = parent.getAttribute('data-range-digits');

    // Format Value
    const formatSlideMin = new Intl.NumberFormat('de-DE', {style: 'decimal', minimumFractionDigits: rangeDigits, maximumFractionDigits: rangeDigits}).format(parseFloat(slideMin));
    const formatSlideMax = new Intl.NumberFormat('de-DE', {style: 'decimal', minimumFractionDigits: rangeDigits, maximumFractionDigits: rangeDigits}).format(parseFloat(slideMax));

    // Range Text
    let rangeText = parent.getAttribute('data-range-text');
    if (rangeText !== null) {
      rangeText = rangeText.replace('{min}', '<span class="min">' + formatSlideMin + '</span>');
      rangeText = rangeText.replace('{max}', '<span class="max">' + formatSlideMax + '</span>');
      displayElement.innerHTML = rangeText;
    } else {
      displayElement.innerHTML = formatSlideMin + ' - ' + formatSlideMax;
    }
  }
};

/**
 * create Range-Slider with input type="range"
 * @param className
 */
window.createRangeSlider = function(className) {
  // Initialize Sliders
  const sliderSections = document.getElementsByClassName(className);
  for (let x = 0; x < sliderSections.length; x++) {
    const sliders = sliderSections[x].getElementsByTagName('input');
    for (let y = 0; y < sliders.length; y++) {
      if (sliders[y].type === 'range') {
        sliders[y].oninput = getSlideVal;
        sliders[y].oninput(this);
      }
    }
  }
};

/**
 * Change nutzhoehe picture
 * @param element
 */
window.changeNutzhoehePicture = function(element) {
  $('#nutzhoehe-smaller-1m, #nutzhoehe-bigger-1m').attr('class', '');

  if (parseFloat($(element).val()) < 1) {
    $('#nutzhoehe-smaller-1m').addClass('display-block');
    $('#nutzhoehe-bigger-1m').addClass('display-none');
  } else {
    $('#nutzhoehe-smaller-1m').addClass('display-none');
    $('#nutzhoehe-bigger-1m').addClass('display-block');
  }
};